/* eslint-disable no-case-declarations */
import { actionCreator } from 'utils';
import {
    LOAD_TEMPLATE,
    SET_TEMPLATE_PAGINATION,
    ADD_TEMPLATE,
    LOAD_EDITTABLE_TEMPLATE,
    SET_EMPTY_EDITTABLE_TEMPLATE,
    EDIT_TEMPLATE,
    SET_TEMPLATE_FILTER,
    RESET_TEMPLATE_FILTERS,
    SET_CHECKED_TEMPLATES,
    TOGGLE_TEMPLATE_STATUS,
    CHECKED_TEMPLATES,
    ADD_BULK_PACKAGES_FOR_TEMPLATE,
    DELETE_BULK_PACKAGES_FOR_TEMPLATE,
    LOAD_PACKAGES_FOR_TEMPLATE,
    UPDATE_PACKAGES_TO_LIST,
    LOAD_EDITTABLE_PACKAGES_FROM_TEMPLATE,
    SET_CHECKED_PACKAGES_FOR_TEMPLATE,
    SET_PACKAGE_PAGINATION_FOR_TEMPLATE,
    SET_PACKAGE_PAGINATION_CHOOSEN,
    SET_FILTER_PACKAGE_FOR_CONFIGURATION,
    SET_PACKAGE_SORT_FOR_TEMPLATE,
    RESET_PACKAGE_FILTERS_FOR_TEMPLATE,
    RESET_PACKAGE_FROM_TEMPLATE,
    RESET_PACKAGE_PAGINATION_FROM_TEMPLATE,
    RESET_PACKAGE_PAGINATION_LIST,
    LOAD_DESIGN_TEMPLATES,
    SET_DESIGN_TEMPLATES_PAGINATION,
    LOAD_EDITABLE_DESIGN_TEMPLATES,
    LOAD_RESELLERS_FOR_DESIGN_TEMPLATES,
    LOAD_PRODUCT_GROUPS_FOR_DESIGN_TEMPLATES,
    EDIT_DESIGN_TEMPLATE,
} from '../types/templateTypes';

const listingPackages = {
    loading: false,
    error: false,
    listing: [],
    offset: 0,
    limit: 10,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    filters: {
        name: '',
        created_by: [],
    },
};

const initState = {
    loading: false,
    error: false,
    success: false,
    listing: null,
    offset: 0,
    limit: 20,
    disable: false,
    listingTemplate: {},
    filters: {
        name: '',
        created_by: [],
    },
    checked: {
        loading: false,
        ids: [],
    },
    addTemp: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    editTemp: {
        loading: false,
        data: null,
        newPackages: [],
        deletePackages: [],
        error: false,
        success: false,
    },
    packages_ids: {
        loading: false,
        error: false,
        success: false,
        data: null,
        offset: 0,
        limit: 10,
    },
    bulk: {
        packages: [],
        loading: false,
        error: false,
    },
    bulkDelete: {
        packages: [],
        loading: false,
        error: false,
    },
    statusLoading: null,
    listingDesignTemplate: {},
    editDesign_template: {
        loading: false,
        error: false,
        data: null,
    },
    resellers: {
        loading: false,
        error: false,
        listing: [],
    },
    productGroups: {
        loading: false,
        error: false,
        listing: [],
    },
    packageConfigurations: { ...listingPackages, limit: 10 },
};

export default function (state = initState, action) {
    switch (action.type) {
    case LOAD_TEMPLATE:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(LOAD_TEMPLATE, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingTemplate: action.data,
        });

    case actionCreator(LOAD_TEMPLATE, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_TEMPLATE_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case SET_TEMPLATE_FILTER:
        return Object.assign({}, state, {
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case RESET_TEMPLATE_FILTERS:
        return Object.assign({}, state, {
            filters: {
                name: '',
            },
        });

    case TOGGLE_TEMPLATE_STATUS:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: action.id,
            },
        });

    case actionCreator(TOGGLE_TEMPLATE_STATUS, 'res') || actionCreator(TOGGLE_TEMPLATE_STATUS, 'err'):
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: false,
            },
        });

    case SET_CHECKED_TEMPLATES:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                ids: action.ids,
            },
        });

    case CHECKED_TEMPLATES:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: action.ids,
            },
        });

    case actionCreator(CHECKED_TEMPLATES, 'res'):
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: false,
                ids: action.ids,
            },
        });

    case actionCreator(CHECKED_TEMPLATES, 'err'):
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: false,
            },
        });

    case ADD_TEMPLATE:
        return Object.assign({}, state, {
            addTemp: Object.assign({}, state.addTemp, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ADD_TEMPLATE, 'res'):
        return Object.assign({}, state, {
            addTemp: Object.assign({}, state.addTemp, {
                loading: action.loading,
                error: false,
                success: action.success,
            }),
        });

    case actionCreator(ADD_TEMPLATE, 'err'):
        return Object.assign({}, state, {
            addTemp: Object.assign({}, state.addTemp, {
                loading: false,
                error: action.error,
            }),
        });

    case LOAD_EDITTABLE_TEMPLATE:
        return Object.assign({}, state, {
            editTemp: Object.assign({}, state.editTemp, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_EDITTABLE_TEMPLATE, 'res'):
        return Object.assign({}, state, {
            editTemp: Object.assign({}, state.editTemp, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(LOAD_EDITTABLE_TEMPLATE, 'err'):
        return Object.assign({}, state, {
            editTemp: Object.assign({}, state.editTemp, {
                loading: false,
                error: true,
            }),
        });

    case SET_EMPTY_EDITTABLE_TEMPLATE:
        return Object.assign({}, state, {
            editTemp: Object.assign({}, state.editTemp, {
                loading: false,
                data: null,
                error: false,
            }),
        });

    case EDIT_TEMPLATE:
        return Object.assign({}, state, {
            editTemp: Object.assign({}, state.editTemp, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(EDIT_TEMPLATE, 'res'):
        return Object.assign({}, state, {
            editTemp: Object.assign({}, state.editTemp, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(EDIT_TEMPLATE, 'err'):
        return Object.assign({}, state, {
            editTemp: Object.assign({}, state.editTemp, {
                loading: false,
                error: true,
            }),
        });

    case ADD_BULK_PACKAGES_FOR_TEMPLATE:
        return Object.assign({}, state, {
            bulk: Object.assign({}, state.bulk, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ADD_BULK_PACKAGES_FOR_TEMPLATE, 'res'):
        return Object.assign({}, state, {
            bulk: Object.assign({}, state.bulk, {
                loading: false,
            }),
        });

    case actionCreator(ADD_BULK_PACKAGES_FOR_TEMPLATE, 'err'):
        return Object.assign({}, state, {
            bulk: Object.assign({}, state.bulk, {
                loading: false,
                error: action.error,
            }),
        });

    case DELETE_BULK_PACKAGES_FOR_TEMPLATE:
        return Object.assign({}, state, {
            bulkDelete: Object.assign({}, state.bulkDelete, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(DELETE_BULK_PACKAGES_FOR_TEMPLATE, 'res'):
        return Object.assign({}, state, {
            bulkDelete: Object.assign({}, state.bulkDelete, {
                loading: false,
            }),
        });

    case actionCreator(DELETE_BULK_PACKAGES_FOR_TEMPLATE, 'err'):
        return Object.assign({}, state, {
            bulkDelete: Object.assign({}, state.bulkDelete, {
                loading: false,
                error: action.error,
            }),
        });

    case UPDATE_PACKAGES_TO_LIST:
        const { payload, id } = action;
        const setReturn = {};

        if (payload === 'new' && 'packages_id' in state.editTemp.data) {
            if (state.editTemp.data.packages_id.includes(id)) {
                setReturn.deletePackages = state.editTemp.deletePackages.filter(p => p !== id);
            } else if (!state.editTemp.newPackages.includes(id)) {
                setReturn.newPackages = state.editTemp.newPackages.concat(id);
            }
        }

        if (payload === 'delete' && 'packages_id' in state.editTemp.data) {
            if (state.editTemp.data.packages_id.includes(id)) {
                setReturn.deletePackages = state.editTemp.deletePackages.concat(id);
            } else if (state.editTemp.newPackages.includes(id)) {
                setReturn.newPackages = state.editTemp.newPackages.filter(p => p !== id);
            }
        }

        return Object.assign({}, state, {
            editTemp: Object.assign({}, state.editTemp, setReturn),
        });

    case RESET_PACKAGE_FROM_TEMPLATE:
        return Object.assign({}, state, {
            editTemp: Object.assign({}, state.editTemp, {
                deletePackages: [],
                newPackages: [],
            }),
        });

    case RESET_PACKAGE_PAGINATION_FROM_TEMPLATE:
        return Object.assign({}, state, {
            packages_ids: Object.assign({}, state.packages_ids, {
                offset: 0,
            }),
        });

    case LOAD_PACKAGES_FOR_TEMPLATE:
        return Object.assign({}, state, {
            packageConfigurations: Object.assign({}, state.packageConfigurations, {
                loading: true,
            }),
        });

    case actionCreator(LOAD_PACKAGES_FOR_TEMPLATE, 'res'):
        return Object.assign({}, state, {
            packageConfigurations: Object.assign({}, state.packageConfigurations, {
                loading: false,
                listing: action.data,
            }),
        });

    case actionCreator(LOAD_PACKAGES_FOR_TEMPLATE, 'err'):
        return Object.assign({}, state, {
            packageConfigurations: Object.assign({}, state.packageConfigurations, {
                loading: false,
                error: true,
            }),
        });

    case LOAD_EDITTABLE_PACKAGES_FROM_TEMPLATE:
        return Object.assign({}, state, {
            packages_ids: Object.assign({}, state.packages_ids, {
                loading: true,
            }),
        });

    case actionCreator(LOAD_EDITTABLE_PACKAGES_FROM_TEMPLATE, 'res'):
        return Object.assign({}, state, {
            packages_ids: Object.assign({}, state.packages_ids, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(LOAD_EDITTABLE_PACKAGES_FROM_TEMPLATE, 'err'):
        return Object.assign({}, state, {
            packages_ids: Object.assign({}, state.packages_ids, {
                loading: false,
                error: true,
            }),
        });

    case SET_CHECKED_PACKAGES_FOR_TEMPLATE:
        return Object.assign({}, state, {
            packageConfigurations: Object.assign({}, state.packageConfigurations, {
                checked: action.ids,
            }),
        });

    case SET_PACKAGE_PAGINATION_FOR_TEMPLATE:
        return Object.assign({}, state, {
            packageConfigurations: Object.assign({}, state.packageConfigurations, {
                [action.key]: action.pagination,
            }),
        });

    case SET_PACKAGE_PAGINATION_CHOOSEN:
        return Object.assign({}, state, {
            packages_ids: Object.assign({}, state.packages_ids, {
                [action.key]: action.pagination,
            }),
        });

    case SET_PACKAGE_SORT_FOR_TEMPLATE:
        return Object.assign({}, state, {
            packageConfigurations: Object.assign({}, state.packageConfigurations, {
                sort: action.sort,
            }),
        });

    case SET_FILTER_PACKAGE_FOR_CONFIGURATION:
        return Object.assign({}, state, {
            packageConfigurations: Object.assign({}, state.packageConfigurations, {
                loading: true,
                filters: {
                    ...state.packageConfigurations.filters,
                    [action.key]: action.value,
                },
            }),
        });

    case actionCreator(SET_FILTER_PACKAGE_FOR_CONFIGURATION, 'res'):
        return Object.assign({}, state, {
            packageConfigurations: Object.assign({}, state.packageConfigurations, {
                loading: false,
                listing: action.data,
            }),
        });

    case RESET_PACKAGE_FILTERS_FOR_TEMPLATE:
        return Object.assign({}, state, {
            packageConfigurations: Object.assign({}, state.packageConfigurations, {
                filters: {
                    name: '',
                    created_by: [],
                },
            }),
        });

    case RESET_PACKAGE_PAGINATION_LIST:
        return Object.assign({}, state, {
            packageConfigurations: Object.assign({}, state.packageConfigurations, {
                offset: 0,
            }),
        });

    case LOAD_DESIGN_TEMPLATES:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(LOAD_DESIGN_TEMPLATES, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingDesignTemplate: action.data,
        });

    case actionCreator(LOAD_DESIGN_TEMPLATES, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_DESIGN_TEMPLATES_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case LOAD_EDITABLE_DESIGN_TEMPLATES:
        return Object.assign({}, state, {
            editDesign_template: Object.assign({}, state.editDesign_template, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_EDITABLE_DESIGN_TEMPLATES, 'res'):
        return Object.assign({}, state, {
            editDesign_template: Object.assign({}, state.editDesign_template, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(LOAD_EDITABLE_DESIGN_TEMPLATES, 'err'):
        return Object.assign({}, state, {
            editDesign_template: Object.assign({}, state.editDesign_template, {
                loading: false,
                error: action.error,
            }),
        });

    case LOAD_RESELLERS_FOR_DESIGN_TEMPLATES:
        return Object.assign({}, state, {
            resellers: Object.assign({}, state.resellers, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_RESELLERS_FOR_DESIGN_TEMPLATES, 'res'):
        return Object.assign({}, state, {
            resellers: Object.assign({}, state.resellers, {
                loading: false,
                listing: action.data,
            }),
        });

    case actionCreator(LOAD_RESELLERS_FOR_DESIGN_TEMPLATES, 'err'):
        return Object.assign({}, state, {
            resellers: Object.assign({}, state.resellers, {
                error: true,
                loading: false,
            }),
        });

    case LOAD_PRODUCT_GROUPS_FOR_DESIGN_TEMPLATES:
        return Object.assign({}, state, {
            productGroups: Object.assign({}, state.productGroups, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_PRODUCT_GROUPS_FOR_DESIGN_TEMPLATES, 'res'):
        return Object.assign({}, state, {
            productGroups: Object.assign({}, state.productGroups, {
                loading: false,
                listing: action.data,
            }),
        });

    case actionCreator(LOAD_PRODUCT_GROUPS_FOR_DESIGN_TEMPLATES, 'err'):
        return Object.assign({}, state, {
            productGroups: Object.assign({}, state.productGroups, {
                error: true,
                loading: false,
            }),
        });

    case EDIT_DESIGN_TEMPLATE:
        return Object.assign({}, state, {
            editDesign_template: Object.assign({}, state.editDesign_template, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(EDIT_DESIGN_TEMPLATE, 'res'):
        return Object.assign({}, state, {
            editDesign_template: Object.assign({}, state.editDesign_template, {
                loading: false,
                success: action.success,
                data: null,
            }),
        });

    case actionCreator(EDIT_DESIGN_TEMPLATE, 'err'):
        return Object.assign({}, state, {
            editDesign_template: Object.assign({}, state.editDesign_template, {
                loading: false,
                success: false,
                error: action.error,
            }),
        });

    default:
        return state;
    }
}
